import React from 'react';
import styles from './LineBreak.less';

function LineBreak() {
  return <div className={styles.lineBreak} />;
}

export default LineBreak;
